<template src="./template.html"></template>
<style lang="scss" src="@/assets/styles/_customs.scss"></style>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'

import { paypalConfig } from 'customerPath/config'

import CartItem from '@/components/QuickCart/CartItem'
import PurchaseSummary from '@/components/modules/PurchaseSummary'
import PaypalCheckout from '@/components/modules/PaypalCheckout'

export default {
  name: 'QuickCart',
  components: {
    CartItem,
    PurchaseSummary,
    PaypalCheckout,
  },
  data() {
    return {
      error: false,
      scrollBoxHeight: 0,
      timer: null,
      paypalConfig,
    }
  },
  computed: {
    ...mapState('cart', [
      'min_order_value',
      'pending',
      'quickCartButton',
      'cart_login',
    ]),
    ...mapState('summary', ['summary']),
    ...mapFields('cart', [
      'quickCartVisible',
      'min_order_value',
    ]),
    hasPaypal() {
      return Boolean(window.config && window.config.paypal_client_id) && this.min_order_value.reached
    },
  },
  watch: {
    async quickCartVisible(val) {
      if (val) {
        this.toggleHtmlClass('no-scrl', 'addClass')
        this.toggleBodyClass('has-mdl', 'addClass')
        await this.getCart()
        if (document.querySelector('.a-A.prod.on') !== null) {
          document.querySelector('.a-A.prod.on').classList && document.querySelector('.a-A.prod.on').classList.remove('on')
        }
        // push event
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'ecommerce': {
            'pageType': 'Cart view event',
          },
        })
        if (this.customer === 'bueffelbill' && this.summary.items.length) {
          const dataLayer_products = this.summary.items.map(item => {
            return {
              id: item.product.articleNumber,
              qty: item.quantity,
              price: item.product.price,
              name: item.product.title,
            }
          })
          window.dataLayer.push({
            'event': 'basket',
            'products': dataLayer_products,
          })
        }
      } else {
        this.toggleHtmlClass('no-scrl')
        this.toggleBodyClass('has-mdl')
      }
    },
    summary(val) {
      this.resizeCartBox()
      const cart = { 'cart': { 'props': { 'count': val.props.count } } }
      // eslint-disable-next-line no-undef
      $.dataPopulate(cart)
      const quickcartCounter = document.querySelectorAll('.cart-count')
      if (quickcartCounter.length && !parseInt(quickcartCounter[0].innerHTML)) {
        quickcartCounter.forEach(elem => elem.classList.add('empty'))
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.resizeCartBox)
  },
  updated() {
    this.$nextTick(() => {
      /* eslint-disable no-undef */
      if (typeof $.adjustRecommendSldrInCart === 'function') {
        $.adjustRecommendSldrInCart(this.$refs.quickcartContent, this.quickCartVisible)
      }
      /* eslint-enable no-undef */
    })
  },
  methods: {
    ...mapActions('cart', [
      'createPaypalPayment',
      'getCart',
    ]),
    showEvent(event) {
      if (event.target.className.includes('quickcart-opener')) {
        this.quickCartVisible = true
      }
    },
    closeCart() {
      this.quickCartVisible = false

      const bonus_products_list = document.querySelector('.bonus-products-list')

      if (
          // eslint-disable-next-line no-undef
          typeof $.updateBonusProducts === 'function'
          && typeof bonus_products_list !== undefined
          && bonus_products_list !== null) {
        // eslint-disable-next-line no-undef
        $.updateBonusProducts()
      }
    },
    goToCheckout() {
      if (!this.min_order_value.reached) {
        this.error = true
        return false
      }
      document.location.href = this.cart_login || `/${this.$i18n.formatedLocale}/checkout/login`
    },
    resizeCartBox() {
      const wrapper = this.$refs.quickcartContent
      if (wrapper) {
        clearTimeout(this.timer)
        // set timeout to prevent browser lags
        this.timer = setTimeout(async _ => {
          await this.$nextTick(_ => {
            this.cartBoxResizer()
            const myObserver = new ResizeObserver(entries => {
              this.cartBoxResizer()
            })
            myObserver.observe(document.querySelector('.cart-footer'))
          })
        }, 250)
      }
    },
    cartBoxResizer() {
      const wrapper = this.$refs.quickcartContent
      const cHeader = wrapper.querySelectorAll('.cart-header')[0]
      const cFooter = wrapper.querySelectorAll('.cart-footer')[0]

      if (cHeader && cFooter) {
        const cartH = window.innerHeight - 40

        // computed styles (margins)
        const cHeaderS = getComputedStyle(cHeader)
        const cFooterS = getComputedStyle(cFooter)

        // calculate the element heights with margins
        const cHeaderH = cHeader.offsetHeight + parseInt(cHeaderS.marginTop) + parseInt(cHeaderS.marginBottom)
        const cFooterH = cFooter.offsetHeight + parseInt(cFooterS.marginTop) + parseInt(cFooterS.marginBottom)
        const scrollBoxHeight = cartH - cHeaderH - cFooterH - 20

        this.scrollBoxHeight = scrollBoxHeight
      }
    },
  },
}
</script>
